export interface WalletOption {
    id: string;
    name: string;
    icon: string;
    description: string;
    provider: "subwallet-js" | "talisman" | "polkadot-js";
    type: "substrate";
}

export const walletOptions: WalletOption[] = [
    {
        id: "subwallet",
        name: "Subwallet",
        icon: "🔗",
        description: "Popular Substrate wallet",
        provider: "subwallet-js",
        type: "substrate",
    },
    {
        id: "talisman",
        name: "Talisman",
        icon: "⚡",
        description: "Talisman wallet for Polkadot ecosystem",
        provider: "talisman",
        type: "substrate",
    },
    {
        id: "polkadot-js",
        name: "Polkadot.js",
        icon: "🟣",
        description: "Official Polkadot.js extension",
        provider: "polkadot-js",
        type: "substrate",
    },
];

export const substrateWallets = walletOptions.filter(
    (wallet) => wallet.type === "substrate"
);
